// source: rag.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_type_date_pb = require('./google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.displayName = 'proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.displayName = 'proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
iccSectionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
sectionNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
sectionTitle: jspb.Message.getFieldWithDefault(msg, 3, ""),
embeddingModel: jspb.Message.getFieldWithDefault(msg, 4, ""),
tokenCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
embeddingDimensionality: jspb.Message.getFieldWithDefault(msg, 6, ""),
dateEmbedded: (f = msg.getDateEmbedded()) && google_type_date_pb.Date.toObject(includeInstance, f),
vectorEmbeddingList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 8)) == null ? undefined : f,
ragFolderPath: jspb.Message.getFieldWithDefault(msg, 9, ""),
contentFilePath: jspb.Message.getFieldWithDefault(msg, 10, ""),
textContent: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord;
  return proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIccSectionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmbeddingModel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTokenCount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmbeddingDimensionality(value);
      break;
    case 7:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDateEmbedded(value);
      break;
    case 8:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedFloat() : [reader.readFloat()]);
      for (var i = 0; i < values.length; i++) {
        msg.addVectorEmbedding(values[i]);
      }
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRagFolderPath(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentFilePath(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIccSectionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSectionNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSectionTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmbeddingModel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTokenCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getEmbeddingDimensionality();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDateEmbedded();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getVectorEmbeddingList();
  if (f.length > 0) {
    writer.writePackedFloat(
      8,
      f
    );
  }
  f = message.getRagFolderPath();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContentFilePath();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTextContent();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string icc_section_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getIccSectionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setIccSectionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string section_number = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getSectionNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setSectionNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string section_title = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getSectionTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setSectionTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string embedding_model = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getEmbeddingModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setEmbeddingModel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 token_count = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getTokenCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setTokenCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string embedding_dimensionality = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getEmbeddingDimensionality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setEmbeddingDimensionality = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.type.Date date_embedded = 7;
 * @return {?proto.google.type.Date}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getDateEmbedded = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 7));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
*/
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setDateEmbedded = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.clearDateEmbedded = function() {
  return this.setDateEmbedded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.hasDateEmbedded = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated float vector_embedding = 8;
 * @return {!Array<number>}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getVectorEmbeddingList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setVectorEmbeddingList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.addVectorEmbedding = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.clearVectorEmbeddingList = function() {
  return this.setVectorEmbeddingList([]);
};


/**
 * optional string rag_folder_path = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getRagFolderPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setRagFolderPath = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string content_file_path = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getContentFilePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setContentFilePath = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string text_content = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.getTextContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.prototype.setTextContent = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.toObject = function(includeInstance, msg) {
  var f, obj = {
recordsList: jspb.Message.toObjectList(msg.getRecordsList(),
    proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords;
  return proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.deserializeBinaryFromReader);
      msg.addRecords(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecordsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VectorEmbeddingRecord records = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord>}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.prototype.getRecordsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord>} value
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords} returns this
*/
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.prototype.setRecordsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord}
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.prototype.addRecords = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords} returns this
 */
proto.org.codetricks.construction.code.assistant.data.rag.VectorEmbeddingRecords.prototype.clearRecordsList = function() {
  return this.setRecordsList([]);
};


goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.data.rag);
